import _ from 'lodash'
import React from 'react'
import T from 'prop-types'
import ReactDOM from 'react-dom'

const GUTTER = 10

const TEXT_STYLES = [
  'fontStyle',
  'fontWeight',
  'fontStretch',
  'fontSize',
  'fontFamily',
  'letterSpacing',
  'lineHeight',
  'color',
  'textShadow'
]

export default class TextOverflowOverlay extends React.Component {
  static displayName = 'TextOverflow.Overlay'

  static propTypes = {
    className: T.string,
    content: T.oneOfType([T.string, T.node]), // Force overlay content
    source: T.oneOfType([T.element, T.object]).isRequired
  }

  constructor(props) {
    super(props)
  }

  UNSAFE_componentWillMount() {
    const {
      content
    } = this.props
    const el = this.props.source
    const rect = el.getBoundingClientRect()
    this.setState({
      left: rect.left + el.clientLeft,
      top: rect.top + el.clientTop,
      width: el.clientWidth,
      textStyles: _.pick(getComputedStyle(el), TEXT_STYLES),
      text: content || el.innerText
    })
  }

  componentDidMount() {
    const { clientWidth, scrollWidth } = ReactDOM.findDOMNode(this)
    let { width, left } = this.state
    const winWidth = window.innerWidth
    width += scrollWidth - clientWidth
    width = Math.min(width, winWidth - GUTTER * 2)
    if (left + width > winWidth - GUTTER) {
      left = winWidth - GUTTER - width
    }
    this.setState({ width, left })
  }

  render() {
    const { state } = this
    const transform = `translate(${Math.round(state.left)}px, ${Math.round(
      state.top
    )}px)`
    const style = _.assign(
      {
        width: Math.ceil(state.width) || 0,
        transform: transform,
        WebkitTransform: transform
      },
      state.textStyles
    )
    return (
      <div
        className={`text_overflow_overlay ${this.props.className || ''}`}
        style={style}
      >
        {state.text}
      </div>
    )
  }
}
